import { Page } from "@/models/page-models/Page";

export const SampleEdit: Page = {
  "path": "sample/:sampleId",
  "name": "Sample",
  "props": {
    "data": {
      "title": "Sample",
      "printable": "FALSE",
      "url": "sample/:sampleId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.sample.data._id",
                  "label": "Doc ID#",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "fetchedData.sample.data.createdAt",
                  "label": "Creation Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{fetchedData.sample.data.createdAt}},show-time)",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "fetchedData.sample.data.updatedAt",
                  "label": "Last Updated",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{fetchedData.sample.data.updatedAt}},show-time)",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "fetchedData.sample.data.createdBy.displayName",
                  "label": "Created By",
                  "printable": false
                }
              ]
            },
            {
              "name": "1 (1)",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Customer",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,customerAlias,{{fetchedData.sample.data.customer}})",
                  "url": "/customers/{{fetchedData.sample.data.customer._id}}",
                  "printable": false
                },
                {
                  "type": "label",
                  "label": "Product",
                  "labelType": "formula",
                  "formula": "fn(CONCAT,{{fetchedData.sample.data.product._id}}, ,fn(HELPER_FN,productAlias,{{fetchedData.sample.data.product}}))",
                  "url": "/products/{{fetchedData.sample.data.product._id}}",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "fetchedData.sample.data.status",
                  "label": "Status",
                  "printable": false
                }
              ]
            },
            {
              "name": "1ba",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.sample.data.failureReason",
                  "label": "Sample Feedback",
                  "showIf": "{{fetchedData.sample.data.failureReason}}",
                  "printable": false
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Failed')"
            },
            {
              "name": "1bb",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.sample.data.feedback",
                  "label": "Sample Feedback",
                  "showIf": "{{fetchedData.sample.data.feedback}}",
                  "printable": false
                },
                {
                  "type": "arrayGroup",
                  "variable": "fetchedData.sample.data.feedbackProof",
                  "label": "Sample Feedback Proof(s)",
                  "disabled": "TRUE",
                  "showIf": "{{fetchedData.sample.data.feedback}}",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "file",
                          "label": "File",
                          "disabled": "TRUE",
                          "color": "secondary",
                          "previewType": "standard"
                        }
                      ]
                    }
                  ],
                  "printable": false
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.quantity",
                  "label": "Sample Quantity",
                  "unit": "{{formData.unit}}",
                  "disabled": "fn(NOT,fn(LOGICAL,fn(MATCH_DEPARTMENT,QA),||,fn(MATCH_ROLE,SALES_MANAGER)))",
                  "printable": false
                },
                {
                  "type": "dropdown",
                  "variable": "formData.unit",
                  "label": "Unit",
                  "disabled": "fn(NOT,fn(LOGICAL,fn(MATCH_DEPARTMENT,QA),||,fn(MATCH_ROLE,SALES_MANAGER)))",
                  "items": "fetchedData.sellingUnits",
                  "printable": false
                },
                {
                  "type": "dropdown",
                  "variable": "formData.sampleType",
                  "label": "Print Type",
                  "disabled": "fn(NOT,fn(LOGICAL,fn(MATCH_DEPARTMENT,QA),||,fn(MATCH_ROLE,SALES_MANAGER)))",
                  "items": "[\"Plain\",\"Printed\"]",
                  "dropdownType": "static"
                }
              ]
            },
            {
              "name": "3a",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.deliverTo",
                  "label": "Delivery To",
                  "disabled": "fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER))",
                  "items": "[\"Sales Office Dammam\",\"Sales Office Riyadh\",\"Sales Office Jeddah\",\"Direct To Customer\"]",
                  "dropdownType": "static",
                  "printable": false
                },
                {
                  "type": "dropdown",
                  "variable": "formData.contactPerson",
                  "label": "Select Contact",
                  "disabled": "fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER))",
                  "items": "fetchedData.contact",
                  "itemText": "firstName",
                  "itemValue": "firstName",
                  "formula": "fn(HELPER_FN,contactName,{{__item}})",
                  "printable": false
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.deliverTo}},'),==,'Direct To Customer')"
            },
            {
              "name": "3b",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.deliverTo",
                  "label": "Delivery To",
                  "disabled": "fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER))",
                  "items": "[\"Sales Office Dammam\",\"Sales Office Riyadh\",\"Sales Office Jeddah\",\"Direct To Customer\"]",
                  "dropdownType": "static",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "formData.contactPerson",
                  "label": "Contact",
                  "printable": false
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.deliverTo}},'),!=,'Direct To Customer')"
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.waybillNumber",
                  "label": "Waybill #",
                  "disabled": "FALSE",
                  "printable": false
                },
                {
                  "type": "input",
                  "variable": "formData.shippingCompany",
                  "label": "Shipping Company",
                  "disabled": "FALSE",
                  "printable": false
                }
              ],
              "disabled": "fn(LOGICAL,fn(NOT,fn(MATCH_DEPARTMENT,QA)),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),!=,'Produced'))"
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "updateSample",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sample/{{__params.sampleId}}",
                        "arg2Key": "requestMethod",
                        "arg2Value": "PATCH",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "updateSample"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Mark as Produced",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "markAsProduced",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sample/{{__params.sampleId}}/mark-produced",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      },
                      "name": "markAsProduced"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Production')",
                  "color": "green",
                  "printable": false
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,PRODUCTION_MANAGER))"
            }
          ],
          "type": "genericGroup",
          "disabled": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Cancelled'),||,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Failed'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Complete')))"
        },
        {
          "groupItems": [
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Cancel",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openCancelPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Cancel Sample"
                      },
                      "name": "openCancelPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Pending'),||,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Production'),||,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Produced'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Hold'))))",
                  "color": "error"
                }
              ],
              "showIf": "fn(MATCH_DEPARTMENT,QA)"
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Cancel",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openCancelPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Cancel Sample"
                      },
                      "name": "openCancelPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Pending')",
                  "color": "error"
                }
              ],
              "showIf": "fn(MATCH_ROLE,SALES_MANAGER)"
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Approve",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "approveSample",
                      "pageFunction": {
                        "name": "approveSample",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sample/{{__params.sampleId}}/approve",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      }
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Pending')",
                  "color": "secondary",
                  "printable": false
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Sales | Manager),||,fn(MATCH_ROLE,General Manager))"
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Dispatch",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Produced')",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "markAsOpen",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sample/{{__params.sampleId}}/mark-dispatched",
                        "arg2Key": "postData",
                        "arg2Value": "\"{}\"",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      }
                    }
                  ],
                  "color": "green",
                  "disabled": "FALSE",
                  "printable": false
                },
                {
                  "type": "button",
                  "label": "Hold",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "markAsProductionHold",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sample/{{__params.sampleId}}/hold",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      },
                      "name": "markAsProductionHold"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Production'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Produced'))",
                  "color": "secondary",
                  "printable": false
                }
              ],
              "showIf": "fn(MATCH_DEPARTMENT,QA)"
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Mark As Production",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "markAsProduction",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sample/{{__params.sampleId}}/unHold",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      },
                      "name": "markAsProduction"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Hold')",
                  "color": "secondary",
                  "printable": false
                }
              ],
              "showIf": "fn(MATCH_DEPARTMENT,QA)"
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Approve",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openCompletePopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Approve Sample"
                      },
                      "name": "openCompletePopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Open')",
                  "color": "secondary",
                  "printable": false
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{fetchedData.sample.data.requests}}),==,0),&&,fn(LOGICAL,fn(MATCH_DEPARTMENT,SALES),||,fn(MATCH_ROLE,General Manager)))"
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Reject",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openRejectionPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Reject Sample"
                      },
                      "name": "openRejectionPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.status}},'),==,'Open')",
                  "color": "error",
                  "printable": false
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{fetchedData.sample.data.requests}}),==,0),&&,fn(LOGICAL,fn(MATCH_DEPARTMENT,SALES),||,fn(MATCH_ROLE,General Manager)))"
            },
            {
              "name": "2c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "View Reject Request",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openRejectRequestPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "View Reject Request"
                      },
                      "name": "openRejectRequestPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.requests.0.type}},'),==,'Failure')",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{fetchedData.sample.data.requests}}),>,0),&&,fn(LOGICAL,fn(MATCH_ROLE,SALES_MANAGER),||,fn(MATCH_ROLE,General Manager)))"
            },
            {
              "name": "2c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "View Approve Request",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openCompleteRequestPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "View Approval Request"
                      },
                      "name": "openCompleteRequestPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.sample.data.requests.0.type}},'),==,'Complete')",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{fetchedData.sample.data.requests}}),>,0),&&,fn(LOGICAL,fn(MATCH_ROLE,SALES_MANAGER),||,fn(MATCH_ROLE,General Manager)))"
            }
          ],
          "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))",
          "type": "genericGroup"
        },
        {
          "type": "genericGroup",
          "groupItems": [
            {
              "name": "1-printonly",
              "pageItems": [
                {
                  "type": "button",
                  "label": "View Loading Manifest",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openSampleLoadingManifest",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/sample-loading-manifest/{{fetchedData.sample.data._id}}"
                      },
                      "name": "openSampleLoadingManifest"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))",
                  "color": "error"
                }
              ]
            }
          ],
          "showIf": "fn(LOGICAL,fn(LOGICAL,{{fetchedData.sample.data.waybillNumber}},==,0),||,fn(NOT,fn(NOT,{{fetchedData.sample.data.waybillNumber}})))"
        },
        {
          "type": "popupGroup",
          "label": "Cancel Sample",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.feedbackForm.feedback",
                  "label": "Reason for rejecting",
                  "disabled": "FALSE",
                  "inputType": "longText"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "fetchedData.feedbackForm.feedbackProof",
                  "label": "Add Proof(s)",
                  "disabled": "FALSE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "file",
                          "label": "Proof",
                          "disabled": "FALSE",
                          "color": "secondary"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "cancelSample",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sample/{{__params.sampleId}}/mark-cancelled",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.feedbackForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PATCH"
                  },
                  "name": "cancelSample"
                },
                {
                  "executionOrder": 3,
                  "pageFunction": {
                    "name": "closeCancelPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Cancel Sample"
                  },
                  "name": "closeCancelPopup"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Reject Sample",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.feedbackForm.feedback",
                  "label": "Reason for rejecting",
                  "disabled": "FALSE",
                  "inputType": "longText"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "fetchedData.feedbackForm.feedbackProof",
                  "label": "Add Proof(s)",
                  "disabled": "FALSE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "file",
                          "label": "Proof",
                          "disabled": "FALSE",
                          "color": "secondary"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Request",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "copySampleCloseFlag",
                  "pageFunction": {
                    "name": "copySampleCloseFlag",
                    "type": "fnCopyData",
                    "arg1Key": "sourceFn",
                    "arg1Value": "getSampleFailFlag",
                    "arg2Key": "destinationKey",
                    "arg2Value": "fetchedData.feedbackForm",
                    "arg3Key": "append",
                    "arg3Value": "TRUE",
                    "arg4Key": "destinationKeyType",
                    "arg4Value": "Object"
                  }
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "requestRejectSample",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sample/{{__params.sampleId}}/request/closing",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.feedbackForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "requestRejectSample"
                },
                {
                  "executionOrder": 3,
                  "pageFunction": {
                    "name": "closeRejectionPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Reject Sample"
                  },
                  "name": "closeRejectionPopup"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "View Reject Request",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.sample.data.requests.0.feedback",
                  "label": "Reason for rejecting",
                  "disabled": "TRUE",
                  "inputType": "longText"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "fetchedData.sample.data.requests.0.feedbackProof",
                  "label": "Add Proof(s)",
                  "disabled": "TRUE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "file",
                          "label": "Proof",
                          "disabled": "FALSE",
                          "color": "secondary",
                          "previewType": "standard"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Reject",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectRejectrequest",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sample/request/failure/{{fetchedData.sample.data.requests.0._id}}/reject",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "GET"
                  },
                  "name": "rejectRejectrequest"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeRejectionRequestPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "View Reject Request"
                  },
                  "name": "closeRejectionRequestPopup"
                }
              ]
            },
            {
              "label": "Approve",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "approveRejectrequest",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sample/request/failure/{{fetchedData.sample.data.requests.0._id}}/approve",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "GET"
                  },
                  "name": "approveRejectrequest"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeRejectionRequestPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "View Reject Request"
                  },
                  "name": "closeRejectionRequestPopup"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Approve Sample",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.feedbackForm.feedback",
                  "label": "Feedback",
                  "disabled": "FALSE",
                  "inputType": "longText"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "fetchedData.feedbackForm.feedbackProof",
                  "label": "Add Proof(s)",
                  "disabled": "FALSE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "file",
                          "label": "Proof",
                          "disabled": "FALSE",
                          "color": "secondary"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Request",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "copySampleCloseFlag",
                  "pageFunction": {
                    "name": "copySampleCloseFlag",
                    "type": "fnCopyData",
                    "arg1Key": "sourceFn",
                    "arg1Value": "getSampleCompleteFlag",
                    "arg2Key": "destinationKey",
                    "arg2Value": "fetchedData.feedbackForm",
                    "arg3Key": "append",
                    "arg3Value": "TRUE",
                    "arg4Key": "destinationKeyType",
                    "arg4Value": "Object"
                  }
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "requestCompleteSample",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sample/{{__params.sampleId}}/request/closing",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.feedbackForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "requestCompleteSample"
                },
                {
                  "executionOrder": 3,
                  "pageFunction": {
                    "name": "closeCompletePopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Approve Sample"
                  },
                  "name": "closeCompletePopup"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "View Approval Request",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.sample.data.requests.0.feedback",
                  "label": "Feedback",
                  "disabled": "TRUE",
                  "inputType": "longText"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "fetchedData.sample.data.requests.0.feedbackProof",
                  "label": "Proof(s)",
                  "disabled": "TRUE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "file",
                          "label": "Proof",
                          "disabled": "TRUE",
                          "color": "secondary",
                          "previewType": "standard"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Reject",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectCompleterequest",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sample/request/complete/{{fetchedData.sample.data.requests.0._id}}/reject",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "GET"
                  },
                  "name": "rejectCompleterequest"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeCompleteRequestPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "View Approval Request"
                  },
                  "name": "closeCompleteRequestPopup"
                }
              ]
            },
            {
              "label": "Approve",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "approvecompleteSamplerequest",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sample/request/complete/{{fetchedData.sample.data.requests.0._id}}/approve",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "GET"
                  },
                  "name": "approvecompleteSamplerequest"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeCompleteRequestPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "View Approval Request"
                  },
                  "name": "closeCompleteRequestPopup"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true,
      "pageComments": {
        "commentsVariable": "fetchedData.sample.data.comments",
        "newCommentVariable": "fetchedData.commentsForm.text",
        "addComentAction": [
          {
            "executionOrder": 1,
            "name": "copyDefaultModel",
            "pageFunction": {
              "name": "copyDefaultModel",
              "type": "fnCopyData",
              "arg1Key": "sourceFn",
              "arg1Value": "getDefaultModel",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentsForm"
            }
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "addComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/sample/{{__params.sampleId}}/add",
              "arg2Key": "postData",
              "arg2Value": "fetchedData.commentsForm",
              "arg3Key": "refreshPage",
              "arg3Value": "TRUE"
            },
            "name": "addComment"
          }
        ],
        "deleteCommentAction": [
          {
            "executionOrder": 1,
            "pageFunction": {
              "name": "copyCommentId",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item._id",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentId"
            },
            "name": "copyCommentId"
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "deleteComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/{{fetchedData.commentId}}/delete?model=quotation",
              "arg2Key": "postData",
              "arg2Value": "{}",
              "arg3Key": "requestMethod",
              "arg3Value": "DELETE",
              "arg4Key": "refreshPage",
              "arg4Value": "TRUE"
            },
            "name": "deleteComment"
          }
        ],
        "updateCommentAction": [
          {
            "executionOrder": 1,
            "pageFunction": {
              "name": "copyCommentId",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item._id",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentId"
            },
            "name": "copyCommentId"
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "copyEditCommentTextForm",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item",
              "arg2Key": "sourceFn",
              "arg2Value": "getEditCommentTextForm",
              "arg3Key": "destinationKey",
              "arg3Value": "fetchedData.editedCommentForm"
            },
            "name": "copyEditCommentTextForm"
          },
          {
            "executionOrder": 3,
            "pageFunction": {
              "name": "updateComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/{{fetchedData.commentId}}/edit",
              "arg2Key": "postData",
              "arg2Value": "fetchedData.editedCommentForm",
              "arg3Key": "requestMethod",
              "arg3Value": "PATCH",
              "arg4Key": "refreshPage",
              "arg4Value": "TRUE"
            },
            "name": "updateComment"
          }
        ]
      }
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getSampleDetail",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/detail?id={{__params.sampleId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.sample"
        },
        "name": "getSampleDetail"
      },
      {
        "executionOrder": 2,
          "pageFunction": {
          "name": "copyCustomerContacts",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.sample.data.customer.contactDetails",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.contact"
        },
        "name": "copyCustomerContacts"
      },
      {
        "executionOrder": 2,
          "pageFunction": {
          "name": "copySampleFormFields",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getSampleFormFields",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copySampleFormFields"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getProductData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/product/detail?id={{fetchedData.sample.data.product._id}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.selectedProduct"
        },
        "name": "getProductData"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "copySellingUnitArray",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getSellingUnitArray",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copySellingUnitArray"
      }
    ],
    "functions": [
      {
        "name": "getEditCommentTextForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "text": "__item.text",
          "model": "__item.targetModel"
        }
      },
      {
        "name": "getSampleFormFields",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "quantity": "{{fetchedData.sample.data.quantity}}",
          "unit": "{{fetchedData.sample.data.unit}}",
          "sampleType": "{{fetchedData.sample.data.sampleType}}",
          "deliverTo": "{{fetchedData.sample.data.deliverTo}}",
          "contactPerson": "{{fetchedData.sample.data.contactPerson}}",
          "waybillNumber": "{{fetchedData.sample.data.waybillNumber}}",
          "shippingCompany": "{{fetchedData.sample.data.shippingCompany}}"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultModel",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "model": "sample",
          "text": "{{fetchedData.commentsForm.text}}"
        },
        "useFormula": true
      },
      {
        "name": "getSellingUnitArray",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "sellingUnits": "fn(HELPER_FN,availableSellingUnits,{{fetchedData.selectedProduct.data.packingMode}})"
        },
        "useFormula": true
      },
      {
        "name": "getSampleFailFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "type": "Failure"
        },
        "staticObject": true
      },
      {
        "name": "getSampleCompleteFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "type": "Complete"
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER,QA_MANAGER,PRODUCTION_MANAGER,QA_TECHNICAL_EXECUTIVE,QA_QUALITY_EXECUTIVE,CUSTOMER_SERVICE_MANAGER",
  "visible": false
}